module.exports = __webpack_public_path__ + "static/media/JP_NS_EYELASHES01.26c5e763.jpg";